import { Dict } from "./en";

/** Eastern Armenian, formal address (Դուք). */
export const hy: Dict = {
  "common.cancel": "Չեղարկել",
  "common.save": "Պահպանել",
  "common.send": "Ուղարկել",
  "common.sending": "Ուղարկվում է…",
  "common.next": "Առաջ",
  "common.change": "Փոխել",
  "common.signIn": "Մուտք",
  "common.return": "Վերադառնալ",
  "common.somethingWrong": "Ինչ-որ բան այն չէ, խնդրում ենք փորձել կրկին",

  "header.language": "Լեզու",
  "header.home": "Գլխավոր",
  "header.shop": "Խանութ",
  "header.account": "Իմ քարտը",
  "header.menu": "Ընտրացանկ",
  "header.support": "Աջակցություն",
  "header.profileSettings": "Պրոֆիլի կարգավորումներ",
  "header.blog": "Բլոգ",
  "header.admin": "Ադմին",
  "header.signOut": "Դուրս գալ",

  "footer.copyright": "© {year} Touch Talk. Բոլոր իրավունքները պաշտպանված են",

  "home.createNfc": "Ստեղծեք Ձեր NFC քարտը",
  "home.createStyle": "Ստեղծեք Ձեր հաղորդակցման ոճը",
  "home.step1": "Ծանոթացեք փաթեթներին",
  "home.step2": "Ստեղծեք Ձեր Talk էջը",
  "home.step3": "Պատվիրեք քարտը և դարձեք հասանելի Ձեր հաճախորդներին",
  "home.getStarted": "Սկսել",
  "home.partners": "Մեր գործընկերները",
  "home.loginHint": "Եթե ունեք հաշիվ, կարող եք մուտք գործել",
  "home.reachTitle": "Մեկ հպում՝ անսահման հասանելիություն",
  "home.reachText": "Ստեղծեք թվային պրոֆիլ Ձեր կոնտակտային տվյալների, սոցիալական հղումների, պորտֆոլիոյի և բիզնեսի մասին տեղեկատվության համար։ Կիսվեք այն ակնթարթորեն՝ ընդամենը մեկ հպումով։",

  "support.link": "Աջակցություն",
  "support.title": "Աջակցության համար",
  "support.success": "Ձեր հաղորդագրությունը հաջողությամբ ուղարկվեց",
  "support.email": "Էլ. փոստ*",
  "support.message": "Հաղորդագրություն*",

  "order.title": "Պատվերի համար",
  "order.package": "Փաթեթ",
  "order.packageOption": "Փաթեթ {title}",
  "order.name": "Անուն*",
  "order.phone": "Հեռախոսահամար*",

  "shop.plans": "ՓԱԹԵԹՆԵՐ",
  "shop.shops": "ԽԱՆՈՒԹ",
  "shop.blurb":
    "Մեկ բաժանորդագրությամբ Դուք ստանում եք ավելին, քան պարզապես թվային այցեքարտ՝ նրբագեղ NFC քարտ, անվճար փոխարինում և աջակցություն ամբողջ տարվա ընթացքում:",
  "shop.nfcCards": "NFC քարտեր",
  "shop.nfcStickers": "NFC ստիկերներ",
  "shop.petTag": "Ընտանի կենդանու պիտակ",
  "shop.mostPopular": "ԱՄԵՆԱՊԱՀԱՆՋՎԱԾԸ",
  "shop.metalCard": "Մետաղյա քարտ",
  "shop.woodenCard": "Փայտե քարտ",
  "shop.emailLabel": "Էլ. փոստի հասցե",
  "shop.phoneLabel": "Հեռախոսահամար",
  "shop.invalidEmail": "Էլ. փոստի հասցեն սխալ է",
  "shop.invalidPhone": "Հեռախոսահամարը սխալ է",
  "shop.submitted": "Ձեր պատվերն ընդունված է: Շուտով կկապվենք Ձեզ հետ:",
  "shop.card": "Քարտ",
  "shop.sales": "Զեղչ",
  "shop.subscriptionFor": "Բաժանորդագրություն՝ {period}",
  "shop.total": "Ընդամենը",
  "shop.order": "Պատվիրել",
  "shop.addons": "Հատուկ հավելումներ",
  "shop.perMonth": "ամսական",
  "shop.getStarted": "Սկսել",
  "shop.addon.metalCard": "Մետաղյա քարտ",

  "plans.basic.title": "ՆԵՐԱՌՈՒՄ Է 1 ՀԱՏ",
  "plans.basic.description": "TOUCH TALK այցեքարտ կամ ստիկեր",
  "plans.pro.title": "ԸՆՏԱՆԻ ԿԵՆԴԱՆՈՒ ՊԻՏԱԿ",
  "plans.pro.description": "և էջի գործառույթ",
  "plans.period.1": "1 ամիս",
  "plans.period.3": "3 ամիս",
  "plans.period.6": "6 ամիս",
  "plans.period.12": "12 ամիս",
  "plans.option.socialNetworks": "Սոցիալական ցանցեր",
  "plans.option.messengers": "Մեսենջերներ",
  "plans.option.url": "Հղում (URL)",
  "plans.option.savingContacts": "Կոնտակտների պահպանում",
  "plans.option.brandedCard": "Բրենդավորված քարտ",
  "plans.option.customButtons": "Էջի կոճակների անհատական ձևավորում",
  "plans.option.background": "Ֆոնի փոփոխման հնարավորություն",
  "plans.option.map": "Քարտեզ",
  "plans.option.review": "Կարծիքներ",
  "plans.option.swipe": "Լուսանկարների սլայդեր Ձեր էջում",
  "plans.option.replacement": "Ստանդարտ PVC քարտի անվճար փոխարինում",
  "plans.option.petPage": "Ընտանի կենդանու էջ",

  "blog.title": "Գաղափարներ ավելի խելացի կապերի համար",
  "blog.all": "Բոլորը",
  "blog.tag": "Թեգ",
  "blog.clear": "մաքրել",
  "blog.by": "հեղինակ՝",
  "blog.noPosts": "Դեռ հոդվածներ չկան:",
  "blog.loadFailed": "Չհաջողվեց բեռնել հոդվածները:",
  "blog.back": "Վերադառնալ բլոգ",
  "blog.notFound": "Հոդվածը չի գտնվել:",
  "blog.sources": "Աղբյուրներ",
  "blog.published": "Հրապարակվել է {date}:",
  "blog.accessed": "Դիտվել է {date}:",

  "pages.plans.title": "Ընտրեք Ձեզ հարմար փաթեթը",
  "pages.plans.cta": "Համեմատել փաթեթները խանութում",
  "pages.partners.title": "Մեզ վստահում են թիմերն ու բիզնեսները",
  "pages.contact.title": "Կապ TouchTalk-ի հետ",
  "pages.contact.cta": "Գրել աջակցությանը",
  "pages.privacy.title": "Գաղտնիության քաղաքականություն",
  "pages.privacy.pending": "Գաղտնիության քաղաքականությունը պատրաստվում է:",
  "pages.terms.title": "Օգտագործման պայմաններ",
  "pages.terms.pending": "Օգտագործման պայմանները պատրաստվում են:",

  "auth.username": "Օգտանուն",
  "auth.password": "Գաղտնաբառ",
  "auth.forgot": "Մոռացե՞լ եք գաղտնաբառը",
  "auth.accept": "Ընդունում եմ",
  "auth.terms": "Օգտագործման պայմանները",
  "auth.signingIn": "Մուտք…",
  "auth.errFields": "Խնդրում ենք լրացնել օգտանունը և գաղտնաբառը",
  "auth.errWrong": "Օգտանունը/էլ. փոստը կամ գաղտնաբառը սխալ է",
  "auth.errServer": "Սերվերը հասանելի չէ: Խնդրում ենք փորձել կրկին:",
  "auth.resetTitle": "Գաղտնաբառի վերականգնում",
  "auth.createTitle": "Գաղտնաբառի ստեղծում",
  "auth.failed": "Չհաջողվեց",
  "auth.resetSubtitle": "Մուտքագրեք Ձեր նոր գաղտնաբառը",
  "auth.newPassword": "Նոր գաղտնաբառ",
  "auth.confirmPassword": "Կրկնեք գաղտնաբառը",
  "auth.confirm": "Հաստատել",
  "auth.mismatch": "Գաղտնաբառերը չեն համընկնում",
  "auth.findAccount": "Գտնել Ձեր հաշիվը",
  "auth.findHint": "Մուտքագրեք Ձեր էլ. փոստը կամ օգտանունը, և մենք կուղարկենք վերականգնման հղում",
  "auth.success": "Հաջողվեց",
  "auth.checkEmail": "Ստուգեք Ձեր էլ. փոստը",
  "auth.notFound": "Ցավոք, Ձեր հաշիվը չգտնվեց: Խնդրում ենք դիմել աջակցությանը:",
  "auth.emailOrUsername": "Էլ. փոստ կամ օգտանուն",

  "settings.profile": "Պրոֆիլի տվյալներ",
  "settings.picture": "Ձեր պրոֆիլի նկարը",
  "settings.pictureTitle": "Պրոֆիլի նկար",
  "settings.name": "Անուն",
  "settings.surname": "Ազգանուն",
  "settings.email": "Էլ. փոստ",
  "settings.phone": "Հեռախոսահամար",
  "settings.updatePassword": "Փոխել գաղտնաբառը",
  "settings.currentPassword": "Ընթացիկ գաղտնաբառ",
  "settings.newPassword": "Նոր գաղտնաբառ",
  "settings.confirmPassword": "Կրկնեք գաղտնաբառը",

  "profile.addToContacts": "Ավելացնել կոնտակտներում",

  "validation.tooLong": "Առավելագույնը {max} նիշ:",
  "validation.pattern": "Խնդրում ենք մուտքագրել տվյալները նշված ձևաչափով:",
  "validation.tooShort": "Առնվազն {min} նիշ:",
  "validation.required": "Այս դաշտը պարտադիր է:",

  "cropper.title": "Կտրել նկարը",
  "cropper.drag": "Քաշեք՝ տեղափոխելու համար",
  "cropper.readError": "Չհաջողվեց կարդալ նկարը: Խնդրում ենք փորձել մեկ այլ նկար:",
  "cropper.uploadError": "Վերբեռնումը չհաջողվեց: Խնդրում ենք փորձել կրկին:",
  "cropper.zoom": "Մասշտաբ",
  "cropper.zoomIn": "Մեծացնել",
  "cropper.zoomOut": "Փոքրացնել",
  "cropper.uploading": "Վերբեռնվում է…",

  "builder.saving": "Պահպանվում է…",
  "builder.saved": "Պահպանված է",
  "builder.saveError": "Չհաջողվեց պահպանել — ստուգեք կապը",

  "tour.skip": "Բաց թողնել",
  "tour.back": "Հետ",
  "tour.next": "Առաջ",
  "tour.done": "Պատրաստ է",
  "tour.stepOf": "{n}/{total}",
  "tour.help": "Ցույց տալ հուշումները",
  "tour.s1.title": "Ձեր քարտը",
  "tour.s1.text": "Սա Ձեր NFC քարտի էջն է: Այն ամենը, ինչ ավելացնում եք այստեղ, երևում է, երբ որևէ մեկը հպվում է Ձեր քարտին:",
  "tour.s2.title": "Ավելացրեք բաժիններ",
  "tour.s2.text": "Սեղմեք «Ավելացնել բաժին»՝ պրոֆիլ, հղումներ, մեսենջերներ, լուսանկարներ կամ քարտեզ ավելացնելու համար:",
  "tour.s3.title": "Խմբագրում և դասավորում",
  "tour.s3.text": "Սեղմեք բաժնի վրա՝ խմբագրելու համար: Քաշեք՝ վերադասավորելու, սահեցրեք ձախ՝ ջնջելու համար:",
  "tour.s4.title": "Նախադիտում",
  "tour.s4.text": "Անցեք նախադիտման՝ տեսնելու, թե ինչ են տեսնում այցելուները:",
  "tour.s5.title": "Կիսվել",
  "tour.s5.text": "Ընտրացանկից պատճենեք Ձեր հղումը, ներբեռնեք QR կոդը կամ փոխեք քարտը:",
  "form.show": "Ցույց տալ",
  "form.hide": "Թաքցնել",
  "cropper.maxSide": "առավելագույնը {px}px",
  "builder.card": "Քարտ",
  "builder.addCard": "Ավելացնել քարտ",
  "builder.adding": "Ավելացվում է…",
  "builder.newCardName": "Նոր քարտ",
  "builder.rename": "Վերանվանել «{name}»",
  "builder.saveName": "Պահպանել անունը",
  "builder.copyLink": "Պատճենել քարտի հղումը",
  "builder.copied": "Պատճենվեց",
  "footer.tagline": "NFC այցեքարտեր, որոնք միշտ աշխատում են․ կիսվեք Ձեր կոնտակտներով, հղումներով և պրոֆիլով մեկ հպումով:",
  "footer.product": "Արտադրանք",
  "footer.company": "Ընկերություն",
  "footer.shop": "Խանութ",
  "footer.plans": "Փաթեթներ",
  "footer.blog": "Բլոգ",
  "footer.partners": "Գործընկերներ",
  "footer.contact": "Կապ",
  "footer.privacy": "Գաղտնիության քաղաքականություն",
  "footer.terms": "Օգտագործման պայմաններ",
  // Hints, help guide and action tooltips (builder).
  "section.text.hint": "Կարճ ներածություն, աշխատանքային ժամեր կամ առաջարկ։",
  "section.link.hint": "Կոճակ, որը բացում է ցանկացած կայք, ֆայլ կամ ամրագրման ձև։",
  "section.profile.hint": "Ձեր լուսանկարը, անունը և պաշտոնը՝ քարտի վերնամասը։",
  "section.messengers.hint": "WhatsApp, Telegram, Instagram և այլն՝ այցելուները սեղմում են և կապվում Ձեզ հետ։",
  "section.swipe.hint": "Լուսանկարների պատկերասրահ․ յուրաքանչյուր լուսանկար կարող է բացել իր հղումը։",
  "section.map.hint": "Ձեր գտնվելու վայրը՝ ճանապարհով։",
  "hint.profile": "Վերբեռնեք քառակուսի լուսանկար, գրեք Ձեր անունը և զբաղմունքը։ Սա այցելուները տեսնում են առաջինը։",
  "hint.text": "Կարճ պահեք․ երկու-երեք տողը հեռախոսում ամենալավն է կարդացվում։ Բառը հղում դարձնելու համար ընտրեք այն և սեղմեք Link։",
  "hint.link": "Տեղադրեք ամբողջական հասցեն (https://…)։ Տվեք կարճ վերնագիր՝ այն կդառնա կոճակի տեքստը։",
  "hint.messengers": "Սեղմեք «Add new section»՝ հավելվածներ ընտրելու համար, ապա գրեք Ձեր համարը կամ պրոֆիլի հղումը։ Այցելուն սեղմում է պատկերակը, և հավելվածը բացվում է Ձեր զրույցով։",
  "hint.swipe": "Ավելացրեք մի քանի լուսանկար։ Յուրաքանչյուր սլայդ կարող է ունենալ իր հղումը․ թողեք դատարկ՝ հիմնական հղումն օգտագործելու համար։",
  "hint.map": "Սեղմեք քարտեզին՝ նշիչը դնելու համար, և գրեք հասցեն։ Այցելուները մեկ հպումով կստանան ճանապարհը։",
  "hint.background": "Ընտրեք գույն կամ վերբեռնեք լուսանկար։ Մուգ ֆոնի վրա սպիտակ տեքստը լավ է կարդացվում։",
  "hint.external": "Օգտագործեք միայն, եթե ուզում եք, որ քարտը Ձեր պրոֆիլի փոխարեն բացի այլ կայք։",
  "help.title": "Ինչպես է աշխատում",
  "help.intro": "Կարճ ուղեցույցներ ամենահաճախ հանդիպող գործողությունների համար։ Սեղմեք թեմայի վրա՝ բացելու համար։",
  "help.profile.title": "Ստեղծեք Ձեր պրոֆիլը",
  "help.profile.s1": "Ներքևում սեղմեք «Add Section» և ընտրեք «Profile pic.»։",
  "help.profile.s2": "Վերբեռնեք քառակուսի լուսանկար․ ընտրված ոճից կախված այն կդառնա շրջանակ կամ շապիկ։",
  "help.profile.s3": "Գրեք Ձեր անունը և պաշտոնը կամ ընկերությունը։",
  "help.profile.s4": "Սեղմեք «Save»։ Այսուհետ փոփոխությունները պահպանվում են ավտոմատ։",
  "help.socials.title": "Ավելացրեք սոցցանցեր և մեսենջերներ",
  "help.socials.s1": "Սեղմեք «Add Section» և ընտրեք «Messengers»։",
  "help.socials.s2": "Սեղմեք «Add new section»՝ ցանկը բացելու համար․ WhatsApp, Telegram, Viber, Instagram, Facebook, LinkedIn, TikTok և այլն։",
  "help.socials.s3": "Նշեք Ձեզ անհրաժեշտ հավելվածները և սեղմեք «Save»։",
  "help.socials.s4": "Յուրաքանչյուր հավելվածի տակ գրեք Ձեր հեռախոսահամարը (մեսենջերներ) կամ պրոֆիլի հղումը (սոցցանցեր)։",
  "help.socials.s5": "«Design» ներդիրում ընտրեք պատկերակներ կամ կոճակներ և գույները։ Ապա «Save»։",
  "help.links.title": "Ավելացրեք հղումներ և ֆայլեր",
  "help.links.s1": "Սեղմեք «Add Section» և ընտրեք «Link»։",
  "help.links.s2": "Գրեք կարճ վերնագիր՝ այն կդառնա կոճակի տեքստը, և տեղադրեք ամբողջական հասցեն՝ սկսած https://-ից։",
  "help.links.s3": "Ցանկության դեպքում վերբեռնեք պատկերակ․ «Design» ներդիրում կարգավորվում են գույները, անկյունները և ստվերը։",
  "help.links.s4": "Սեղմեք «Save»։ Ավելացրեք այնքան հղում, որքան պետք է՝ կայք, մենյու, գնացուցակ, ամրագրում, PDF։",
  "help.photos.title": "Ավելացրեք լուսանկարներ",
  "help.photos.s1": "Սեղմեք «Add Section» և ընտրեք «Swipe Photo»։",
  "help.photos.s2": "Սեղմեք «Upload photo» և կտրեք յուրաքանչյուր նկարը (բոլոր սլայդներն ունեն նույն 4:3 շրջանակը)։",
  "help.photos.s3": "Տվեք սլայդին իր հղումը կամ նշեք մեկ հիմնական հղում բոլոր սլայդների համար։",
  "help.photos.s4": "Միացրեք «Autoswipe», եթե ուզում եք, որ պատկերասրահն ինքնուրույն շարժվի։ Ապա «Save»։",
  "help.map.title": "Ավելացրեք Ձեր գտնվելու վայրը",
  "help.map.s1": "Սեղմեք «Add Section» և ընտրեք «Map»։",
  "help.map.s2": "Սեղմեք քարտեզին՝ նշիչը դնելու համար, և գրեք հասցեն ու վերնագիրը։",
  "help.map.s3": "Սեղմեք «Save»։ Այցելուները մեկ հպումով կբացեն ճանապարհը։",
  "help.background.title": "Փոխեք ֆոնը",
  "help.background.s1": "Ներքևում սեղմեք մատիտի կոճակը և ընտրեք «Change profile background»։",
  "help.background.s2": "Ընտրեք գույն կամ վերբեռնեք լուսանկար (9:16-ը լավագույնն է հեռախոսների համար)։",
  "help.background.s3": "Սեղմեք «Save»։ Յուրաքանչյուր բաժնի տեքստի գույնը կարգավորվում է իր «Design» ներդիրում։",
  "help.cards.title": "Ձեր քարտերը",
  "help.cards.s1": "Քարտը մեկ հանրային էջ է՝ իր հղումով և QR կոդով։ Ձեր պատվիրած յուրաքանչյուր NFC քարտ բացում է դրանցից մեկը։",
  "help.cards.s2": "Կառուցիչի վերևի անունը ընթացիկ քարտն է։ Սեղմեք դրա վրա՝ քարտերի միջև անցնելու համար։",
  "help.cards.s3": "Այդ ցանկում սեղմեք «Add card»՝ նոր քարտ ստեղծելու համար՝ երկրորդ բիզնեսի, թիմի անդամի կամ միջոցառման համար։",
  "help.cards.s4": "Սեղմեք քարտի կողքի մատիտը՝ այն վերանվանելու համար։",
  "help.cards.s5": "Քարտը հեռացնելու համար բացեք ներքևի մատիտի ընտրացանկը և ընտրեք «Delete this card»։",
  "help.share.title": "Կիսվեք Ձեր քարտով",
  "help.share.s1": "Սեղմեք քարտի անվան կողքի հղման պատկերակը՝ հանրային հղումը պատճենելու համար։",
  "help.share.s2": "Մատիտի ընտրացանկում ընտրեք «Show QR code»՝ QR-ը ցուցադրելու կամ ներբեռնելու համար։",
  "help.share.s3": "Ֆիզիկական TouchTalk քարտի դեպքում այցելուն պարզապես հպում է հեռախոսը քարտին․ հավելված պետք չէ։",
  "help.share.s4": "Մատիտի ընտրացանկում միացրեք «Show contact saver», որ այցելուները մեկ հպումով Ձեզ ավելացնեն կոնտակտներում։",
  "help.order.title": "Պատվիրեք ֆիզիկական քարտ",
  "help.order.s1": "Բացեք խանութը և ընտրեք քարտի դիզայն ու փաթեթ։",
  "help.order.s2": "Լրացրեք պատվերի ձևը․ մենք կկապվենք Ձեզ հետ մանրամասները հաստատելու համար։",
  "help.order.s3": "Քարտը ստանալիս այն արդեն բացում է Ձեր պրոֆիլը․ այն ամենը, ինչ այստեղ կառուցում եք, աշխատում է քարտի վրա։",
  "help.order.cta": "Անցնել խանութ",
  "help.replayTour": "Կրկնել ուղեցույցը",
  "help.showHints": "Ցույց տալ հուշումները նորից",
  "help.hintsReset": "Հուշումները նորից կերևան",
  "tip.preview": "Դիտել որպես այցելու",
  "tip.edit": "Վերադառնալ խմբագրմանը",
  "tip.menu": "Ընտրացանկ․ QR կոդ, ֆոն, բաժինների հեռացում",
  "tip.drag": "Քաշեք՝ վերադասավորելու համար",
  "tip.help": "Ինչպես է աշխատում",
};
